import React from "react";
import { fg_positive } from "../../../tokens";

type Props = {
  fill?: string;
  className?: string;
};

export function AIScheduler({ fill = fg_positive, className }: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.75 20.25H2.75C2.33579 20.25 2 19.9142 2 19.5V4.5C2 4.08579 2.33579 3.75 2.75 3.75H17.75C18.1642 3.75 18.5 4.08579 18.5 4.5V8.25H2"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 2.25V5.25"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 2.25V5.25"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7351 15.8801L20.0921 16.8522C20.0371 16.8723 19.9871 16.9042 19.9457 16.9457C19.9042 16.9871 19.8723 17.0371 19.8522 17.0921L18.8801 19.7351C18.8514 19.8128 18.7996 19.8799 18.7317 19.9272C18.6637 19.9746 18.5828 20 18.5 20C18.4172 20 18.3363 19.9746 18.2683 19.9272C18.2004 19.8799 18.1486 19.8128 18.1199 19.7351L17.1478 17.0921C17.1277 17.0371 17.0958 16.9871 17.0543 16.9457C17.0129 16.9042 16.9629 16.8723 16.9079 16.8522L14.2649 15.8801C14.1872 15.8514 14.1201 15.7996 14.0728 15.7317C14.0254 15.6637 14 15.5828 14 15.5C14 15.4172 14.0254 15.3363 14.0728 15.2683C14.1201 15.2004 14.1872 15.1486 14.2649 15.1199L16.9079 14.1478C16.9629 14.1277 17.0129 14.0958 17.0543 14.0543C17.0958 14.0129 17.1277 13.9629 17.1478 13.9079L18.1199 11.2649C18.1486 11.1872 18.2004 11.1201 18.2683 11.0728C18.3363 11.0254 18.4172 11 18.5 11C18.5828 11 18.6637 11.0254 18.7317 11.0728C18.7996 11.1201 18.8514 11.1872 18.8801 11.2649L19.8522 13.9079C19.8723 13.9629 19.9042 14.0129 19.9457 14.0543C19.9871 14.0958 20.0371 14.1277 20.0921 14.1478L22.7351 15.1199C22.8128 15.1486 22.8799 15.2004 22.9272 15.2683C22.9746 15.3363 23 15.4172 23 15.5C23 15.5828 22.9746 15.6637 22.9272 15.7317C22.8799 15.7996 22.8128 15.8514 22.7351 15.8801Z"
        fill={fill}
      />
    </svg>
  );
}
